export default __webpack_public_path__ + "static/media/290.8059a10c.jpg";